import {faInfoCircle} from '@fortawesome/pro-solid-svg-icons';
import {Trigger} from '@radix-ui/react-tooltip';
import clsx from 'clsx';

import {Icon} from '../Icon/Icon';

import type {TooltipTriggerProps} from '@radix-ui/react-tooltip';

export function TooltipTrigger({
  ref: forwardedRef,
  children,
  className,
  ...props
}: TooltipTriggerProps &
  React.RefAttributes<HTMLButtonElement>): React.JSX.Element {
  const styles = clsx(className, 'text-blue11');

  const _children = children || (
    <Icon icon={faInfoCircle} className={styles} size="xs" />
  );

  return (
    <Trigger
      {...props}
      ref={forwardedRef}
      className={styles}
      asChild={!!children}
    >
      {_children}
    </Trigger>
  );
}

TooltipTrigger.displayName = 'TooltipTrigger';
